import PaginationComponent from '@/components/common/PaginationComponent';
import WithHyperLinkComponent from '@/components/common/WithHyperLinkComponent';
import ListMagazineLine from '@/components/common/communication/magazine/ListMagazineLine';
import { ROUTES } from '@/types/common';
import { MagazineByAuthorPublicIdVo } from '@/views/magazine-author-detail/model/magazine';
import MagazineListByAuthorEmpty from './MagazineListByAuthorEmpty';

interface Props {
  magazineByAuthorPublicId?: MagazineByAuthorPublicIdVo | null;
  paginationBaseUrl: string;
  currentPage: number;
  queries: { page: string };
}

const MagazineListByAuthor = ({ magazineByAuthorPublicId, paginationBaseUrl, currentPage, queries }: Props) => {
  if (!magazineByAuthorPublicId) return null;
  return (
    <div className={'pb-[80px]'}>
      <h2 className={'typography-ui-22sb p-[32px_24px_24px] pt-[32px] text-gray-700'}>최신 콘텐츠</h2>
      {magazineByAuthorPublicId.magazines.length === 0 ? (
        <MagazineListByAuthorEmpty />
      ) : (
        <>
          <ul>
            {magazineByAuthorPublicId.magazines.map((magazine, index) => (
              <WithHyperLinkComponent
                key={magazine.magazinePid}
                href={`${ROUTES.MAGAZINE.DETAIL.path}/${magazine.magazinePid}`}
                target={'_self'}
              >
                <ListMagazineLine
                  key={index}
                  titleAsH2={false}
                  magazine={{
                    magazinePid: magazine.magazinePid,
                    title: magazine.title,
                    mobileTitle: magazine.mobileTitle,
                    image: magazine.titleImageUrl,
                    date: magazine.getFormattedCreatedAt(),
                    description: magazine.description,
                    mobileDescription: magazine.mobileDescription,
                  }}
                />
              </WithHyperLinkComponent>
            ))}
          </ul>
          <PaginationComponent
            baseUrl={paginationBaseUrl}
            queries={queries}
            currentPage={currentPage}
            perPage={5}
            totalPage={magazineByAuthorPublicId.totalPageCount}
          />
        </>
      )}
    </div>
  );
};

export default MagazineListByAuthor;
